function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { deepMix } from '@antv/util';
import { WordCloud as WordCloudTransform } from '../data';
function initializeData(data, encode) {
  var _encode$text = encode.text,
    text = _encode$text === void 0 ? 'text' : _encode$text,
    _encode$value = encode.value,
    value = _encode$value === void 0 ? 'value' : _encode$value;
  return data.map(function (d) {
    return Object.assign(Object.assign({}, d), {
      text: d[text],
      value: d[value]
    });
  });
}
var GET_DEFAULT_LAYOUT_OPTIONS = function GET_DEFAULT_LAYOUT_OPTIONS(width, height) {
  return {
    size: [width, height]
  };
};
var GET_DEFAULT_OPTIONS = function GET_DEFAULT_OPTIONS(width, height) {
  return {
    axis: false,
    type: 'text',
    encode: {
      x: 'x',
      y: 'y',
      text: 'text',
      rotate: 'rotate',
      fontSize: 'size'
    },
    scale: {
      x: {
        domain: [0, width],
        range: [0, 1]
      },
      y: {
        domain: [0, height],
        range: [0, 1]
      },
      fontSize: {
        type: 'identity'
      },
      rotate: {
        type: 'identity'
      }
    },
    style: {
      textAlign: 'center'
    }
  };
};
export var WordCloud = function WordCloud(options, context) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee() {
    var width, height, data, _options$encode, encode, scale, _options$style, style, _options$layout, layout, resOptions, initializedData, transformData;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          width = context.width, height = context.height;
          data = options.data, _options$encode = options.encode, encode = _options$encode === void 0 ? {} : _options$encode, scale = options.scale, _options$style = options.style, style = _options$style === void 0 ? {} : _options$style, _options$layout = options.layout, layout = _options$layout === void 0 ? {} : _options$layout, resOptions = __rest(options, ["data", "encode", "scale", "style", "layout"]);
          initializedData = initializeData(data, encode);
          _context.n = 1;
          return WordCloudTransform(Object.assign(Object.assign({}, GET_DEFAULT_LAYOUT_OPTIONS(width, height)), layout))(initializedData);
        case 1:
          transformData = _context.v;
          return _context.a(2, deepMix({}, GET_DEFAULT_OPTIONS(width, height), Object.assign(Object.assign({
            data: transformData,
            encode: encode,
            scale: scale,
            style: style
          }, resOptions), {
            axis: false
          })));
      }
    }, _callee);
  }));
};
WordCloud.props = {};